
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The file component <strong>delivers downloadable content</strong> to users in
  an easy to use container. When the file is available in more than one language
  the file component makes these files accessible in an expandable sub
  container.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/File/Download2.jpg" alt="Anatomy of file download" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <h3>{`Default`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Heading must describe the downloadable file accurately`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`File Details`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`File Details displays the `}<strong parentName="td">{`file language, file type and file size`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Link downloads the file when selected`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Conditional (translated/multiple languages)`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Button, when selected, displays the file in different languages available, `}<strong parentName="td">{`below the download container`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Language`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Language of the downloaded content `}<strong parentName="td">{`acting as a heading`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper Text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper Text assists the user in selecting the appropriate file and language`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`the heading of each item should be`}</strong>{` short, distinct and indicative`}</li>
      <li parentName="ul">{`always include the `}<strong parentName="li">{`file language, file type and file size`}</strong></li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't use without additional relevant content`}</strong>{` on the same page`}</li>
      <li parentName="ul"><strong parentName="li">{`don't use the same heading as the file name`}</strong></li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`when you want to include additional relevant or supporting documents for download`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`Do not use to include `}<strong parentName="li">{`important information`}</strong>{` that should be present at all time`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;